module.exports = __webpack_public_path__ + "llama-circle.749e883929357392cdce117c006b1730.svg";